<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <!-- MainView -->
      <!-- <article class="wrapper wrapper-content main-column"> -->
      <article @click.self="open = false" :class="{ 'full-column' : !open }" class="wrapper wrapper-content main-column">
        <!-- ViewTitleBox -->
        <div class="ibox-tools view-title">
            <h1 class="info-menu view-name">
              <img src="static/img/assets/nav_1on1_on.png" alt="">
              {{$t('viewName.oneRequestRece')}}
            </h1>
            <span class="info-right">
              <button @click="histryDelete" type="button" class="btn btn-danger block m-b">{{$t('oneRequestClearStr')}}</button>
            </span>
        </div>
        <!-- /ViewTitleBox -->
        <section class="animated fadeInRight">
          <template>
            <!-- 1on1item -->
            <div class="ibox">
              <div class="ibox-content flex-option">

                <div v-if="!getCurrent1on1sRequest.get1on1" class="ibox-child one-child cursor">
                  <div class="history-item">
                    <span class="one-item-text">
                      {{$t('notFoundOneRequest')}}
                    </span>
                  </div>
                </div>
                <div v-for="getItem in getCurrent1on1sRequest.get1on1" :key="getItem.id" @click="onClickGetItem(getItem)" class="ibox-child one-child cursor">
                  <div class="flex-box cursor">
                    <img class="one-icon" src="static/img/assets/nav_1on1_on.png" alt="">
                    <div class="comment">
                      <div class="flex-box fl-between">
                        <h4 class="h3">{{$t('oneOnTileType')}}</h4>
                        <div><span class="info-comment-detail">
                          <span>{{ getItem.createdAt | preparedTime }}</span>
                        </span></div>
                      </div>
                      <div><span>{{ getRequestsByNoticeType(getItem) }}</span></div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /ibox-content -->
          </div>
          <!-- /1on1item -->
        </template>

      </section>
    </article>

      <!-- DetailView -->
      <div id="detailView" class="sub-column" :class="{ 'sub-active' : open }">
        <div class="close-content"><div @click="open = false" class="close-btn cursor"><i class="fa fa-angle-right"></i></div></div>
        <article class="sub-content-wrap">
          <section class="inner-wrap">
            <div class="s-inner-wrap">
              <div class="ibox-title flex-box fl-between ibox-detail-header">
                <span class="info-menu flex-box">{{$t('oneOnRequestListTileType')}}</span>
                <span class="info-right"></span>
              </div>
              <div v-if="this.targetGetItem && this.targetGetItem.contentText" class="ibox">
                <div class="ib-sub-content">
                    <div class="ibox-title">
                        <h4 class="h3"> <label class="request-header">{{$t('senderStr')}}</label>{{ getLatestTargetUserName }}</h4>
                    </div>
                    <div class="ibox-child detail-head">
                        <p class="font-bold">{{ $t('commentLabelTitle') }}</p>
                        <p v-html="this.targetGetItem.contentText" v-linkified:options="{validate: httpValidation}">
                          <!--<read-more :text="this.targetGetItem.contentText" :addMore="true" :showMore="this.propShowMore" :contentHeight="this.propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight">-->
                          <!--</read-more>-->
                        </p>
                    </div>
                </div>
              </div>
            </div>
          </section>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import OneSentItem from '@/components/One/OneSentItem'
import ReadMore from '@/components/ReadMore/ReadMoreComponent'
import moment from 'moment'
import linkify from 'vue-linkify'

export default {
  name: 'OneRequestRece',
  components: {
    OneSentItem,
    ReadMore
  },
  directives: {
    linkified: linkify
  },
  data: function () {
    return {
      httpValidation: {
        url: function (value) {
          return /^(http)s?:\/\//.test(value)
        }
      },
      tag: 'progress',
      open: false,
      targetGetItem: {},
      propShowMore: false,
      propContentHeight: 0
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'OneRequestRece'
    },
    ...mapGetters([
      'getUserId'
    ]),
    ...mapGetters('ones/', [
      'getCurrent1on1sRequest'
    ]),
    ...mapGetters('users/', [
      'getUserInfoById'
    ]),
    oneOnRequestMsgString () { return this.$t('oneOnRequestMsgString') },
    getLatestTargetUserName: function () {
      if (
        this.targetGetItem.userId &&
        this.getUserInfoById(this.targetGetItem.userId).userName
      ) {
        return this.getUserInfoById(this.targetGetItem.userId).userName
      } else {
        return this.targetGetItem.userId || ''
      }
    }
  },
  mounted: function () {
    // console.log('this.$route.params', this.$route.params)
    if (this.$route.params.item) {
      this.targetGetItem = this.getCurrent1on1sRequest.get1on1[this.$route.params.item['1on1requests']]
      // console.log('targetGetItem', this.targetGetItem)
      if (this.targetGetItem) {
        if (!this.open) {
          this.open = true
        }
      } else {
        const $t = this.$t
        this.$swal({
          title: $t('popTitleStrType'),
          text: $t('deletedOneOnOneRequest'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      }
    } else {
      if (this.getUserId) {
        let now = new Date().getTime() / 1000
        this.set1on1ReqLastNotice(now)
        console.log('1on1ReqRecv:mounted', this.getUserId, now)
      }
    }
  },
  updated () {
  },
  methods: {
    ...mapActions('ones/', {
      set1on1ReqLastNotice: 'SET_1ON1REQ_LAST_NOTICE',
      removeGetHistry: 'REMOVE_GET_1ON1S'
    }),
    onClickGetItem: function (getItem) {
      this.targetGetItem = getItem
      if (!this.open) {
        this.open = true
      }
    },
    histryDelete: function () {
      const $t = this.$t
      if (Object.keys(this.getCurrent1on1sRequest).filter(x => x === 'send1on1').length === 1) {
        this.$swal({
          // sweetAlartの処理
          title: $t('popTitleStrType'),
          text: $t('doDeleteStr'),
          showCancelButton: true,
          cancelButtonColor: '#f64846',
          type: 'warning',
          confirmButtonClass: 'btn btn-success',
          cancelButtonClass: 'btn btn-danger',
          reverseButtons: false,
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          allowOutsideClick: false,
          padding: '2rem'
          // timer: 3000
        }).then((result) => {
          if (result.value) {
            console.log('isDelete = true')
            console.log(this.getUserId)
            this.removeGetHistry(this.getUserId)
            this.$swal({
              title: $t('compDeleteStr'),
              type: 'success',
              animation: false,
              customClass: 'animated fadeInUp',
              // customClass: 'animated flipInX',
              width: '35rem',
              position: 'center',
              // toast: true,
              padding: '2rem',
              timer: 3000
            })
            if (this.open) {
              this.open = false
            }
          } else {
            console.log('isDelete = false')
            console.log(Object.keys(this.getCurrent1on1sRequest))
          }
        })
      } else {
        this.$swal({
          title: $t('notExistOneRequestStr'),
          type: 'warning',
          animation: false,
          customClass: 'animated fadeInUp',
          // customClass: 'animated flipInX',
          width: '35rem',
          position: 'center',
          // toast: true,
          padding: '2rem',
          timer: 3000
        })
      }
    },
    updateShowMore: function (value) {
      this.propShowMore = value
    },
    updateContentHeight: function (value) {
      this.propContentHeight = value
    },
    getRequestsByNoticeType (getItem) {
      let contentText
      if (this.getUserInfoById(getItem.userId).userName) {
        contentText = this.oneOnRequestMsgString.replace('{$user}', this.getUserInfoById(getItem.userId).userName)
      } else {
        contentText = getItem.userName + this.oneOnRequestMsgString
      }
      return contentText
    }
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.flex-option{
    display: flex;
    flex-direction: column-reverse;
  }
  .ibox-child:first-of-type {
    border-top: solid 1px #e7eaec;
  }
  .ibox-child:last-of-type {
    border-top: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/views/notice/OneRequestRece.vue